export default class SelectedService {
  public placeId: number
  public serviceId: number
  public addonServiceIds: Array<number> = []
}
